import { AppNotification } from '../utils/types/data/services/notification';
import { api } from '../providers/base-api';

export function getNotificationsRequest(params?: {
  limit?: number;
  offset?: number;
}) {
  return api.get<AppNotification[]>('/notifications', { params });
}

export function markNotificationsReadRequest() {
  return api.patch<void>('/notifications/read');
}

export function deleteReadNotificationsRequest() {
  return api.delete<void>('/notifications/read');
}
